<template>
  <base-auth-form :signup-mode="false" />
</template>

<script>
import BaseAuthForm from '@/components/auth/BaseAuthForm'

export default {
  components: {
    BaseAuthForm,
  }
}
</script>

<style lang="scss" scoped></style>
